import { cn } from '@v2/shared/lib/utils';
import Container from '@v2/shared/components/Container';
import { SALE_CONTAINER } from '@v2/shared/lib/megaSale';

export type SaleBannerProps = {
  banner: {
    desktop: string;
    desktopColor?: string | null;
    mobile?: string | null;
    mobileColor?: string | null;
    alt: string;
  } | null;
};

/**
 * The sale's own artwork.
 *
 * Two images rather than one responsive one, because they are different artwork and not
 * two sizes of the same thing — the mobile banner is a separate upload with its own
 * background colour. The colours are the only inline styles on this page and they have
 * to be: they come from the section row, per sale, so there is no class to name.
 *
 * A sale without a mobile banner shows the desktop one at every width, which is what the
 * legacy template did.
 *
 * Inside the content box rather than bleeding the full window width. The artwork is drawn
 * at a page width — 994px on the legacy layout, which is where these files are still cut
 * to — so a full-bleed strip on a wide monitor is a small picture marooned in the middle
 * of a coloured band. Boxed, it starts and ends level with the products under it.
 */
export default function SaleBanner({ banner }: SaleBannerProps) {
  if (!banner) {
    return null;
  }

  return (
    <Container className={cn('pt-4', SALE_CONTAINER)}>
      <div
        className={banner.mobile ? 'hidden md:block text-center' : 'block text-center'}
        style={{ backgroundColor: banner.desktopColor || '#ffffff' }}
      >
        <img src={banner.desktop} alt={banner.alt} className="inline-block max-w-full h-auto" />
      </div>
      {banner.mobile && (
        <div className="md:hidden text-center" style={{ backgroundColor: banner.mobileColor || '#ffffff' }}>
          <img src={banner.mobile} alt={banner.alt} className="inline-block max-w-full h-auto" />
        </div>
      )}
    </Container>
  );
}
